

// export async function sentimentMaker(res:any, selectedDate:any, sentimentType:any){
//     let news_sentiment:any = res.news_sentiment;
//     let niftyData:any = res.niftyData;
//     let j_accuracy:any = {}
//     let j_pl:any = {}

    
//     try{
//         if (res.news_sentiment?.length > 0){
//             let premarket_sentiment:any = news_sentiment[0]["n_premarket_sentiment"]
//             let accuracy:any = news_sentiment[0]["j_accuracy"] !==null ? news_sentiment[0]["j_accuracy"] : {}
//             let totalPL:any = news_sentiment[0]["j_pl"] !==null ? news_sentiment[0]["j_pl"] : {}

//             if (Object.keys(accuracy).length > 0){
//                 let key:any =  Object.keys(accuracy).pop()
//                 j_accuracy = accuracy[key]
//             }
//             if (Object.keys(totalPL).length > 0){
//                 let key:any =  Object.keys(totalPL).pop()
//                 j_pl = totalPL[key]
//             }
            
//             let news_Signals:any = news_sentiment[0].j_sentiment !== null ? news_sentiment[0].j_sentiment : {};
//             if(sentimentType === 'updated'){
//                 news_Signals = news_sentiment[0].j_sentiment_updated !== null ? news_sentiment[0].j_sentiment_updated : {};
//             }
            
//             let signal_data:any = []
//             let total_nifty_data:any = niftyData[0]['j_ohlc']
            
//             if ((Object.keys(news_Signals).length > 0) && (Object.keys(total_nifty_data).length > 0)){
//                 Object.keys(total_nifty_data).map((item:any)=>{
//                     if (Object.keys(news_Signals).includes(item)){
//                         if (news_Signals[item] > 0){
//                            let obj:any = {"date":selectedDate+' '+item,
//                                             "open":total_nifty_data[item][0],
//                                             "high":total_nifty_data[item][1],
//                                             "low":total_nifty_data[item][2],
//                                             "close":total_nifty_data[item][3],
//                                             "buy"  :  true,
//                                             "value" :  news_Signals[item]
//                                         }
//                             signal_data.push(obj)
//                         }
//                         else{
//                             let obj:any = {"date":selectedDate+' '+item,
//                                             "open":total_nifty_data[item][0],
//                                             "high":total_nifty_data[item][1],
//                                             "low":total_nifty_data[item][2],
//                                             "close":total_nifty_data[item][3],
//                                             "sell"  :  true,
//                                             "value" :  news_Signals[item]
//                                         }
//                             signal_data.push(obj)
//                         }
//                     }
//                     else{
//                         let obj:any = {"date":selectedDate+' '+item,
//                                             "open":total_nifty_data[item][0],
//                                             "high":total_nifty_data[item][1],
//                                             "low":total_nifty_data[item][2],
//                                             "close":total_nifty_data[item][3]
//                                         }
//                         signal_data.push(obj)
//                     }
//                 })

//                 return {
//                     "news_sentiment": {
//                                         "n_premarket_sentiment":premarket_sentiment,
//                                         "j_accuracy"  : j_accuracy,
//                                         "j_pl" : j_pl,
//                                         "signal_data" : signal_data,
//                                         "j_sentiment_length" : (Object.keys(news_sentiment[0].j_sentiment_updated))?.length
//                                         },
//                         // "n_news_252_acc": n_news_252_acc,
//                         // "n_eco_252_acc" : n_eco_252_acc,
//                         // "n_news_21_acc" : n_news_21_acc,
//                         // "n_eco_21_acc"  : n_eco_21_acc
//                     }
//             }
//             else if((Object.keys(news_Signals)?.length === 0) && (Object.keys(total_nifty_data).length > 0)){
//                 Object.keys(total_nifty_data).map((item:any)=>{
//                     if (Object.keys(news_Signals).includes(item)){
//                         if (news_Signals[item] > 0)
//                         {
//                            let obj:any = {"date":selectedDate+' '+item,
//                                             "open":total_nifty_data[item][0],
//                                             "high":total_nifty_data[item][1],
//                                             "low":total_nifty_data[item][2],
//                                             "close":total_nifty_data[item][3],
//                                             "buy"  :  true,
//                                             "value" :  news_Signals[item]
//                                         }
//                             signal_data.push(obj)
//                         }
//                         else{
//                             let obj:any = {"date":selectedDate+' '+item,
//                                             "open":total_nifty_data[item][0],
//                                             "high":total_nifty_data[item][1],
//                                             "low":total_nifty_data[item][2],
//                                             "close":total_nifty_data[item][3],
//                                             "sell"  :  true,
//                                             "value" :  news_Signals[item]
//                                         }
//                             signal_data.push(obj)
//                         }
//                     }
//                     else{
//                         let obj:any = {"date":selectedDate+' '+item,
//                                             "open":total_nifty_data[item][0],
//                                             "high":total_nifty_data[item][1],
//                                             "low":total_nifty_data[item][2],
//                                             "close":total_nifty_data[item][3]
//                                         }
//                         signal_data.push(obj)
//                     }
//                 })

//                 return {
//                     "news_sentiment": {
//                                         "n_premarket_sentiment":premarket_sentiment,
//                                         "j_accuracy"  : j_accuracy,
//                                         "j_pl" : j_pl,
//                                         "signal_data" : signal_data,
//                                         "j_sentiment_length" : news_sentiment[0].j_sentiment_updated !== null ?  (Object.keys(news_sentiment[0].j_sentiment_updated))?.length : 0
//                                         },
//                         // "n_news_252_acc": n_news_252_acc,
//                         // "n_eco_252_acc" : n_eco_252_acc,
//                         // "n_news_21_acc" : n_news_21_acc,
//                         // "n_eco_21_acc"  : n_eco_21_acc
//                     }
//             }
//         }
//         else{
//             return {
//                     "news_sentiment" : {},
//                     // "n_news_252_acc" : n_news_252_acc,
//                     // "n_news_21_acc"  : n_news_21_acc,
//                     // "n_eco_21_acc"   : n_eco_21_acc,
//                     // "n_eco_252_acc"  : n_eco_252_acc
//                 }
//         }
//     }
//     catch{
//         return {
//             "news_sentiment" : {},
//             // "n_news_252_acc" : n_news_252_acc,
//             // "n_news_21_acc"  : n_news_21_acc,
//             // "n_eco_21_acc"   : n_eco_21_acc,
//             // "n_eco_252_acc"  : n_eco_252_acc
//         }
//     }
// }


export async function sentimentMaker(res: any, selectedDate: any, sentimentType: any) {
    let news_sentiment: any = res.news_sentiment;
    let niftyData: any = res.niftyData;
    let j_accuracy: any = {};
    let j_pl: any = {};

    try {
        // Check if `news_sentiment` is available
        if (!news_sentiment || news_sentiment.length === 0) {
            // `news_sentiment` is absent, proceed only with `niftyData`
            let signal_data: any = [];
            let total_nifty_data: any = niftyData[0]?.j_ohlc || {};

            Object.keys(total_nifty_data).map((item: any) => {
                let obj: any = {
                    "date": selectedDate + ' ' + item,
                    "open": total_nifty_data[item][0],
                    "high": total_nifty_data[item][1],
                    "low": total_nifty_data[item][2],
                    "close": total_nifty_data[item][3]
                };
                signal_data.push(obj);
            });

            return {
                "news_sentiment": {
                    "n_premarket_sentiment": 0,
                    "j_accuracy": j_accuracy,
                    "j_pl": j_pl,
                    "signal_data": signal_data,
                    "j_sentiment_length": 0
                }
            };
        } else {
            // `news_sentiment` is available, proceed with existing logic
            let premarket_sentiment: any = news_sentiment[0]["n_premarket_sentiment"];
            let accuracy: any = news_sentiment[0]["j_accuracy"] !== null ? news_sentiment[0]["j_accuracy"] : {};
            let totalPL: any = news_sentiment[0]["j_pl"] !== null ? news_sentiment[0]["j_pl"] : {};

            if (Object.keys(accuracy).length > 0) {
                let key: any = Object.keys(accuracy).pop();
                j_accuracy = accuracy[key];
            }
            if (Object.keys(totalPL).length > 0) {
                let key: any = Object.keys(totalPL).pop();
                j_pl = totalPL[key];
            }

            let news_Signals: any = news_sentiment[0].j_sentiment !== null ? news_sentiment[0].j_sentiment : {};
            if (sentimentType === 'updated') {
                news_Signals = news_sentiment[0].j_sentiment_updated !== null ? news_sentiment[0].j_sentiment_updated : {};
            }

            let signal_data: any = [];
            let total_nifty_data: any = niftyData[0]?.j_ohlc || {};

            if ((Object.keys(news_Signals).length > 0) && (Object.keys(total_nifty_data).length > 0)) {
                Object.keys(total_nifty_data).map((item: any) => {
                    if (Object.keys(news_Signals).includes(item)) {
                        let obj: any = {
                            "date": selectedDate + ' ' + item,
                            "open": total_nifty_data[item][0],
                            "high": total_nifty_data[item][1],
                            "low": total_nifty_data[item][2],
                            "close": total_nifty_data[item][3],
                            "value": news_Signals[item]
                        };
                        if(news_Signals[item] != 0) news_Signals[item] > 0 ? obj.buy = true : obj.sell = true;
                        signal_data.push(obj);
                    } else {
                        let obj: any = {
                            "date": selectedDate + ' ' + item,
                            "open": total_nifty_data[item][0],
                            "high": total_nifty_data[item][1],
                            "low": total_nifty_data[item][2],
                            "close": total_nifty_data[item][3]
                        };
                        signal_data.push(obj);
                    }
                });

                return {
                    "news_sentiment": {
                        "n_premarket_sentiment": premarket_sentiment,
                        "j_accuracy": j_accuracy,
                        "j_pl": j_pl,
                        "signal_data": signal_data,
                        "j_sentiment_length": Object.keys(news_sentiment[0].j_sentiment_updated || {}).length
                    }
                };
            }else{
                return {
                    "news_sentiment": {}
                };
            }
        }
    } catch (error) {        
        return {
            "news_sentiment": {}
        };
    }
}


export async function stockSignalMaker(
    stockDailyData: { dt_date: string; n_open: number; n_high: number; n_low: number; n_close: number }[],
    allStock: { s_symbol: string; dt_open_date?: string; dt_close_date?: string }[],
    selectedStock: any
): Promise<{ signalArray: Array<{ date: string; open: number; high: number; low: number; close: number; buy?: boolean; sell?: boolean; value?: number }>; noOfLongCalls: number,lastBuyDate:any,lastSellDate:any }> {
   
    let mainResponse: Array<{ date: string; open: number; high: number; low: number; close: number; buy?: boolean; sell?: boolean; value?: number }> = [];
    let noOfLongCalls = 0;
    let lastSellDate = '';
    let lastBuyDate = '';

    try {
        if (stockDailyData.length === 0 || allStock.length === 0) {
            return { signalArray: mainResponse, noOfLongCalls ,lastBuyDate,lastSellDate};
        }

        const selectedStockData:any = allStock.filter((stock:any) =>
            stock.s_symbol === selectedStock.s_symbol
        );
       
        const signals: { [date: string]: number } = selectedStockData.reduce((acc:any, stock:any) => {
            if (stock.dt_open_date) acc[stock.dt_open_date] = 1;
            // if (stock.dt_close_date && stock.s_status!='') acc[stock.dt_close_date] = -1;
            if (stock.dt_close_date && (stock.s_status!='' && stock.s_status!=null)) acc[stock.dt_close_date] = -1;

            return acc;
        }, {});
       
        stockDailyData.sort((a, b) => new Date(a.dt_date).getTime() - new Date(b.dt_date).getTime());
        stockDailyData.forEach(data => {
            const signalValue = signals[data.dt_date];
            let obj: { date: string; open: number; high: number; low: number; close: number; buy?: boolean; sell?: boolean; value?: number } = {
                date: data.dt_date,
                open: data.n_open,
                high: data.n_high,
                low: data.n_low,
                close: data.n_close
            };
           
            if (signalValue) {
                if (signalValue > 0) {
                    obj.buy = true;
                    obj.value = signalValue;
                    noOfLongCalls++;
                    lastBuyDate = data.dt_date;
                } else if (signalValue < 0) {
                    obj.sell = true;
                    obj.value = signalValue;
                    lastSellDate = data.dt_date;
                }
            }
            mainResponse.push(obj);
        });
        if (new Date(lastBuyDate) > new Date(lastSellDate)) {
            noOfLongCalls--;
        }
        return { signalArray: mainResponse, noOfLongCalls,lastBuyDate,lastSellDate };
       
    } catch (error) {
        console.error('Error in stockSignalMaker:', error);
        return { signalArray: mainResponse, noOfLongCalls,lastBuyDate,lastSellDate };
    }
}

// Function to find the nearest date
export async function findNearestDate(dateString:any, data:any) {
let dates:any = Object.keys(data);
    if (dates.includes(dateString)) {
        return data[dateString];
    }

    // Convert dates to timestamps for comparison
    let targetDate:any = new Date(dateString).getTime();
    let nearestDate:any = null;
    let minDiff:any = Infinity;

    // Iterate over existing dates to find the nearest one
    for (let date of dates) {
        let currentDate = new Date(date).getTime();
        let diff = Math.abs(currentDate - targetDate);
        if (diff < minDiff) {
        minDiff = diff;
        nearestDate = date;
        }
    }

    return data[nearestDate];
}



export const calculate_m2m_graph = (values: any, page: string) => {
    let points = 10
    try {
        if (page === 'live') { //for live trades
            let final_arr = []
            let arr_length = values.length;
            if (arr_length > points) {
                let divider = Math.floor(arr_length / points)
                for (let i = 1; i < arr_length; i = i + divider) {
                    final_arr.push(values[i].value)
                }
            }
            else {
                for (let i = 0; i < arr_length; i++) {
                    final_arr.push(values[i].value)
                }
            }
            return final_arr
        }
        else { //for back dated trades
            let arr = Object.keys(values)
            let final_arr = []
            let arr_length = arr.length;
            if (arr_length > points) {
                let divider = Math.floor(arr_length / points)

                for (let i = 1; i < arr_length; i = i + divider) {
                    final_arr.push(values[arr[i]])
                }
            }
            else {
                for (let i = 0; i < arr_length; i++) {
                    final_arr.push(values[arr[i]])
                }
            }
            return final_arr
        }
    } catch (error) {
        console.log("Error in calculate_m2m_graph function : ", error);
        return []
    }
}

export const calculate_theme_color = (theme:any) =>{
    
    if (theme === 'light') {
        return "rgb(64, 64, 64)";
      }
    else if (theme === 'dark') {
        return "rgb(235, 235, 235)";
    }
    else if (theme === 'b&w') {
        return "rgb(235, 235, 235)";
    }
}


